import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BaseModal from "@/views/modals/BaseModal.vue";
import useModal from "@/hooks/useModal";
import Modals from "@/utils/Modals";
import CoveredModal from "@/views/modals/context/CoveredModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CoverageInfo',
  setup(__props) {

const modalLabel = Modals.COVERED_MODAL.label;
const { toggleModal } = useModal();
const showAccidentalDamageModal = () => {
  toggleModal(Modals.COVERED_MODAL.label);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("section", { class: "blue-sec" }, [
      _createElementVNode("div", {
        class: "container aos-init aos-animate",
        "data-aos": "fade-down",
        "data-aos-duration": "2000"
      }, [
        _createElementVNode("h2", null, "What does Renters Insurance cover?"),
        _createElementVNode("p", null, [
          _createTextVNode(" Renters Insurance liability insurance covers the housing owner's property when it gets damaged/destroyed due to resident-caused fire, water damage*, smoke or explosion. The resident's personal belongings can be covered from fire, theft, explosion & other covered incidents. Your policy will cover the cost to repair or replace property when the unexpected happens. "),
          _createElementVNode("br"),
          _createElementVNode("small", null, " *In North Carolina, water damage liability is optional for Renters Insurance. ")
        ])
      ])
    ], -1)),
    _createVNode(BaseModal, { name: _unref(modalLabel) }, {
      default: _withCtx(() => [
        _createVNode(CoveredModal)
      ]),
      _: 1
    }, 8, ["name"])
  ], 64))
}
}

})